import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { User } from '../../../domain/users/models/User';
import { UsersState, initialUsersState } from './usersState';

const usersSlice = createSlice({
    name: 'users',
    initialState: initialUsersState,
    reducers: {
        setUsers: (state: UsersState, action: PayloadAction<User[]>) => {
            state.users = action.payload;
        },
        setSelectedUser: (state: UsersState, action: PayloadAction<User | undefined>) => {
            state.selectedUser = action.payload;
        },
        setPinnedAgentIds: (state: UsersState, action: PayloadAction<string[]>) => {
            state.pinnedAgentIds = action.payload;
        },
        setTotalItems: (state: UsersState, action: PayloadAction<number>) => {
            state.totalItems = action.payload;
        },
        setPageNumber: (state: UsersState, action: PayloadAction<number>) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state: UsersState, action: PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setSearchTerm: (state: UsersState, action: PayloadAction<string>) => {
            state.searchTerm = action.payload;
        },
        setIsLoading: (state: UsersState, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setError: (state: UsersState, action: PayloadAction<string | undefined>) => {
            state.error = action.payload;
        },
    },
});

export const {
    setUsers,
    setSelectedUser,
    setPinnedAgentIds,
    setTotalItems,
    setPageNumber,
    setPageSize,
    setSearchTerm,
    setIsLoading,
    setError,
} = usersSlice.actions;

export default usersSlice.reducer;
